import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Link as MuiLink,
} from "@mui/material";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";

const footerSections = [
  {
    title: "Shop",
    links: [
      { label: "Listings", path: "/listings" },
      { label: "Classes", path: "/classes" },
      { label: "Services", path: "/services" },
      { label: "Shop", path: "/shop" },
    ],
  },
  {
    title: "Help",
    links: [
      { label: "Contact Us", path: "/contact" },
      { label: "Pricing", path: "/pricing" },
      { label: "Policy", path: "/policy" },
      { label: "Terms", path: "/conditions" },
    ],
  },
  {
    title: "About",
    links: [
      { label: "About Us", path: "/about" },
      { label: "Media", path: "/media" },
      { label: "Education", path: "https://education.mooreexotics.com", external: true },
      { label: "Neighborhood", path: "/neighborhood" },
    ],
  },
];

const socialLinks = [
  { icon: FacebookIcon, label: "Facebook", url: "https://www.facebook.com/mooreexotics" },
  { icon: InstagramIcon, label: "Instagram", url: "https://instagram.com/mooreexotics" },
  { icon: YouTubeIcon, label: "YouTube", url: "https://www.youtube.com/channel/UCcv8tPRfz8XW-FD4lePXjww" },
  { icon: TwitterIcon, label: "Twitter", url: "https://twitter.com/mooreexotics" },
];

const Footer = ({ user }) => {
  return (
    <Box sx={{ backgroundColor: "#111", pt: { xs: 4, md: 6 }, pb: 3 }}>
      <Container maxWidth="xl">
        {/* Footer Columns */}
        <Grid container spacing={{ xs: 3, md: 4 }}>
          {/* Shop, Help, About columns */}
          {footerSections.map((section) => (
            <Grid item xs={6} sm={3} key={section.title}>
              <Typography
                sx={{
                  color: "#FFC001",
                  fontWeight: 700,
                  fontSize: { xs: "15px", md: "17px" },
                  mb: 1.5,
                }}
              >
                {section.title}
              </Typography>
              {section.links.map((link) =>
                link.external ? (
                  <MuiLink
                    key={link.label}
                    href={link.path}
                    target="_self"
                    sx={{
                      display: "block",
                      color: "#ccc",
                      fontSize: { xs: "13px", md: "14px" },
                      textDecoration: "none",
                      lineHeight: "28px",
                      "&:hover": { color: "#FFC001" },
                    }}
                  >
                    {link.label}
                  </MuiLink>
                ) : (
                  <Typography
                    key={link.label}
                    component={Link}
                    to={link.path}
                    sx={{
                      display: "block",
                      color: "#ccc",
                      fontSize: { xs: "13px", md: "14px" },
                      textDecoration: "none",
                      lineHeight: "28px",
                      "&:hover": { color: "#FFC001" },
                    }}
                  >
                    {link.label}
                  </Typography>
                )
              )}
            </Grid>
          ))}

          {/* Connect column */}
          <Grid item xs={6} sm={3}>
            <Typography
              sx={{
                color: "#FFC001",
                fontWeight: 700,
                fontSize: { xs: "15px", md: "17px" },
                mb: 1.5,
              }}
            >
              Connect
            </Typography>
            {socialLinks.map((social) => (
              <MuiLink
                key={social.label}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  color: "#ccc",
                  fontSize: { xs: "13px", md: "14px" },
                  textDecoration: "none",
                  lineHeight: "28px",
                  "&:hover": { color: "#FFC001" },
                }}
              >
                <social.icon sx={{ fontSize: 18 }} />
                {social.label}
              </MuiLink>
            ))}

            {/* Login link for logged-out users */}
            {!user?.email && (
              <Typography
                component={Link}
                to="/auth/login"
                sx={{
                  display: "block",
                  color: "#ccc",
                  fontSize: { xs: "13px", md: "14px" },
                  textDecoration: "none",
                  lineHeight: "28px",
                  mt: 1,
                  "&:hover": { color: "#FFC001" },
                }}
              >
                Login
              </Typography>
            )}
          </Grid>
        </Grid>

        {/* Divider */}
        <Box sx={{ borderTop: "1px solid #333", mt: { xs: 3, md: 4 }, pt: 3 }}>
          {/* Logo */}
          <Box sx={{ textAlign: "center", mb: 1.5 }}>
            <Link to="/">
              <img
                src="https://res.cloudinary.com/dwezij7u7/image/upload/v1675115795/exoticslogo_w2oi9z.png"
                alt="Moore Exotics logo"
                style={{
                  width: "180px",
                  height: "auto",
                  filter: "brightness(0) invert(1)",
                }}
              />
            </Link>
          </Box>

          {/* Copyright */}
          <Typography
            sx={{
              textAlign: "center",
              color: "#666",
              fontSize: "12px",
            }}
          >
            &copy; {new Date().getFullYear()} Moore Exotics. All Rights Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

const mapStateToProps = ({ Auth }) => ({
  user: Auth.user,
});

export default connect(mapStateToProps)(Footer);
